import styled from "styled-components";
import { Link } from "react-router-dom";
import { StyledLink } from "../utils/button";
import { IconContext } from "react-icons";
import { IoMdCloseCircle } from "react-icons/io";
import check from "../assets/checkout-check.svg";
import "../styles/modal.css";

interface baseModalProps {
  banner: string;
  title: string;
  details: string;
  price: string;
  setmodal: React.Dispatch<React.SetStateAction<boolean>>;
}

interface checkoutModal {
  setmodalstyle: React.Dispatch<React.SetStateAction<boolean>>;
}

const StyledDiv = styled.div`
  h4,
  h3 {
    color: var(--vidomCustomBlue);
    font-weight: 600;
    font-size: 1.5em;
  }
  h3,
  p {
    font-size: 0.75em;
  }
  img {
    width: 91px;
    height: 81px;
    margin-right: 1em;
    border-radius: 10px;
  }
`;
const BannerDiv = styled(StyledDiv)`
  justify-content: space-between;
  flex-direction: row;
  display: flex;
  padding: 0 0.5em;
  align-items: center;
`;
const ContentDiv = styled(BannerDiv)`
  border: 1px solid rgba(0, 0, 0, 0.21);
  padding: 0.5em;
  align-items: start;
  margin-right: 1em;
  margin-top: 4em;
  border-radius: 10px;
  p {
    color: var(--vidomGray);
  }
  p span {
    font-size: 1.333em;
    font-weight: 700;
    color: var(--vidomOrange);
    margin-top: 0.5em;
    text-decoration: underline;
  }
`;
const Buttondiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2em;
`;
const CheckoutDiv = styled(Buttondiv)`
  flex-direction: column;
  padding-right: 1em;
  margin-top: 1em;
  text-align: center;
  h3 {
    font-size: 1.5em;
    color: var(--vidomGray);
    font-weight: 400;
    margin: 0.5em 0;
  }
  p {
    color: var(--vidomGray);
    margin-bottom: 2em;
  }

  @media (min-width: 801px) {
    br {
      display: none;
    }
  }

  a {
    font-size: 1.125em;
  }
`;

const IconDiv = styled.div`
  justify-content: flex-end;
  display: flex;
`;

export const CheckoutModal = ({ setmodalstyle }: checkoutModal) => {
  const handleClick = () => {
    setmodalstyle((prevModal) => !prevModal);
  };
  return (
    <div>
      <IconDiv>
        <Link to="/dashboard">
          <IconContext.Provider value={{ className: "modal-check-close" }}>
            <IoMdCloseCircle onClick={handleClick} />
          </IconContext.Provider>
        </Link>
      </IconDiv>
      <CheckoutDiv>
        <img
          src={check}
          alt="check"
        />
        <h3>Payment Successful!</h3>
        <p>
          You can now explore the <br /> benefits of Vidom
        </p>
        <StyledLink to="/dashboard">Go to Dashboard</StyledLink>
      </CheckoutDiv>
    </div>
  );
};

const Modal = ({ banner, title, details, price, setmodal }: baseModalProps) => {
  const handleClick = () => {
    setmodal((prevModal) => !prevModal);
  };

  return (
    <StyledDiv>
      <BannerDiv>
        <h4>Added to cart</h4>
        <IconContext.Provider value={{ className: "modal-close" }}>
          <IoMdCloseCircle onClick={handleClick} />
        </IconContext.Provider>
      </BannerDiv>
      <ContentDiv>
        <img
          src={banner}
          alt="course"
        />
        <div>
          <h3>{title}</h3>
          <p>{details}</p>
          <p>
            <span>{price}</span>
          </p>
        </div>
      </ContentDiv>
      <Buttondiv>
        <StyledLink to="/cart">Go to Cart</StyledLink>
      </Buttondiv>
    </StyledDiv>
  );
};

export default Modal;
